import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { API_CONFIG } from '../api/config';

const TokenReceiver: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const token = searchParams.get('token');

        if (token) {
            const tokenStrDecoded = atob(token);
            const tokenJson = tokenStrDecoded?.split('__ih__');
            localStorage.setItem('auth_token', token);
            localStorage.setItem('LOGISTICS_REQUESTER_ID', tokenJson[0]);
            navigate('/', { replace: true });
        } else {
            // No token provided — redirect to login
            // window.location.href = API_CONFIG.ONBOARDING_URL + '/login';
        }
    }, [searchParams, navigate]);

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: 'var(--ih-theme-bg-primary)' }}>
            <p style={{ color: 'var(--ih-theme-text-tertiary)', fontSize: '14px', fontFamily: 'var(--ih-font-family-primary)' }}>Authenticating...</p>
        </div>
    );
};

export default TokenReceiver;
